import { isBefore, addMinutes, areIntervalsOverlapping } from 'date-fns';

export default {
    data: () => ({
        appointmentStatuses: [
            { id: 11, label: 'Annulation par l\'acquéreur', color: 'red lighten-2', textColor: 'red--text text--lighten-2' },
            { id: 12, label: 'Annulation par le vendeur', color: 'red lighten-2', textColor: 'red--text text--lighten-2' },
            { id: 255, label: 'Réalisé', color: 'green lighten-2', textColor: 'green--text text--lighten-2' },
            { id: 0, label: 'Planifié', color: 'blue ligthen-2', textColor: 'blue--text text--ligthen-2' },
            { id: null, label: 'Non programmé', color: 'grey ligthen-2', textColor: 'grey--text text--ligthen-2' }
        ]
    }),

    methods: {
        getAppointmentStatusColor(id) {
            let item = this.appointmentStatuses.find((o) => o.id === id);
            if (!item) {
                item = this.appointmentStatuses.find((o) => o.id === 0);
            }
            return item.color;
        },
        getAppointmentStatusLabel(id) {
            let item = this.appointmentStatuses.find((o) => o.id === id);
            if (!item) {
                item = this.appointmentStatuses.find((o) => o.id === 0);
            }
            return item.label;
        },
        getAppointmentStatusTextColor(id) {
            let item = this.appointmentStatuses.find((o) => o.id === id);
            if (!item) {
                item = this.appointmentStatuses.find((o) => o.id === 0);
            }
            return item.textColor;
        },

        getDisponibilityHours(appointment, instances, disponibility) {
            const availableSlots = [];

            const dispoStart = new Date(disponibility.startDate);
            const dispoEnd = new Date(disponibility.endDate);

            const parsedInstances = instances.filter((instance) => ![11, 12].includes(instance.status)).map(instance => ({
                start: new Date(instance.startDate),
                end: new Date(instance.endDate)
            }));

            let current = dispoStart;

            while (isBefore(addMinutes(current, appointment.duration), dispoEnd) || +addMinutes(current, appointment.duration) === +dispoEnd) {
                const slotStart = current;
                const slotEnd = addMinutes(current, appointment.duration);

                const hasOverlap = parsedInstances.some(instance =>
                    areIntervalsOverlapping(
                        { start: slotStart, end: slotEnd },
                        { start: instance.start, end: instance.end }
                    )
                );

                if (!hasOverlap) {
                    availableSlots.push(slotStart);
                }

                current = addMinutes(current, 30);
            }

            return availableSlots;
        }
    }
};
